import { ColumnType } from "antd/es/table"
import { IProjectDataKeywords } from "../types/projectDataKeywords.types"
import HeaderWithPeriodBadge from "../ui/HeaderWithPeriodBadge"
import { Space } from "antd"
import NotAvailableTagKeyword from "../../../ui/NotAvailableTagKeyword"

const useProjectDataKeywordsColumns = (keywords: IProjectDataKeywords[]) => {
  const columnWidth = "100px"

  const columns: ColumnType<IProjectDataKeywords>[] = [
    {
      title: `Keyword (${keywords.length})`,
      dataIndex: "keywordText",
      key: "keywordText",
      render: (keywordText: string, record: IProjectDataKeywords) => {
        return (
          <Space>
            {keywordText}
            <NotAvailableTagKeyword state={record.state} />
          </Space>
        )
      },
    },
    {
      title: <HeaderWithPeriodBadge headerText={`Clicks`} />,
      dataIndex: "clicks",
      key: "clicks",
      width: columnWidth,
      render: (clicks: number) => clicks || 0,
    },
    {
      title: <HeaderWithPeriodBadge headerText={`Sales`} />,
      dataIndex: "sales",
      key: "sales",
      width: columnWidth,
      render: (sales: number) => sales || 0,
    },
    {
      title: <HeaderWithPeriodBadge headerText={`Conversion`} />,
      dataIndex: "conversion",
      key: "conversion",
      width: columnWidth,
      render: (conversion: number) => (conversion ? conversion.toFixed(2) + "%" : 0),
    },
    {
      title: <HeaderWithPeriodBadge headerText={`Sales Distribution`} />,
      dataIndex: "distribution",
      key: "distribution",
      width: columnWidth,
      render: (distribution: number) => (distribution ? distribution + "%" : 0),
    },
    {
      title: `Organic rank`,
      dataIndex: "organicPosition",
      key: "organicPosition",
      width: columnWidth,
      render: (organicPosition: number) => organicPosition || 0,
    },
    {
      title: `Sponsored Rank`,
      dataIndex: "sponsoredPosition",
      key: "sponsoredPosition",
      width: columnWidth,
      render: (sponsoredPosition: number) => sponsoredPosition || 0,
    },
  ]

  return columns
}

export default useProjectDataKeywordsColumns
